var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-page"},[_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.type))]),_c('main-content-area',{attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }